export default function WhyChooseUs() {
  const steps = [
    {
      number: '1',
      title: 'Stuur je ritgegevens',
      description: 'Ophaaladres, datum, tijd en bestemming'
    },
    {
      number: '2',
      title: 'Ontvang bevestiging',
      description: 'En eventueel vaste prijs'
    },
    {
      number: '3',
      title: 'Chauffeur haalt je op',
      description: 'En brengt je veilig naar de luchthaven'
    }
  ];

  const faqs = [
    {
      question: 'Wat kost een airport taxi vanuit Utrecht?',
      answer: 'De prijs hangt af van de bestemming en het tijdstip. Voor veel ritten kunnen we vooraf een vaste prijs afspreken. Neem contact op voor een directe prijsindicatie.'
    },
    {
      question: 'Zijn jullie ook \'s nachts beschikbaar?',
      answer: 'Ja, wij rijden 24/7, ook voor vroege ochtendvluchten en nachtelijke aankomsten.'
    },
    {
      question: 'Helpen chauffeurs met bagage?',
      answer: 'Ja, wij helpen altijd met in- en uitladen van bagage.'
    },
    {
      question: 'Hoe kan ik reserveren?',
      answer: 'Via WhatsApp, telefonisch of via het reserveringsformulier.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* How it Works */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Hoe werkt reserveren
            </h2>
            <p className="text-lg text-slate-600">
              In 3 eenvoudige stappen naar uw airport taxi
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-slate-50 rounded-xl p-8 text-center h-full">
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <i className="ri-arrow-right-line text-3xl text-amber-500"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Veelgestelde vragen over airport taxi Utrecht
            </h2>
          </div>

          <div className="max-w-4xl mx-auto space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-slate-50 rounded-xl p-6 hover:shadow-md transition-shadow">
                <h3 className="text-xl font-bold text-slate-900 mb-3 flex items-start gap-3">
                  <i className="ri-question-line text-amber-500 mt-1"></i>
                  {faq.question}
                </h3>
                <p className="text-slate-700 leading-relaxed pl-8">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Local Text */}
        <div className="mt-16 bg-amber-50 rounded-xl p-8 text-center">
          <p className="text-lg text-slate-700 leading-relaxed">
            Wij halen klanten op in heel Utrecht, waaronder <strong>Leidsche Rijn</strong>, <strong>Lombok</strong>, <strong>Oog in Al</strong>, <strong>Overvecht</strong>, <strong>Kanaleneiland</strong> en het <strong>centrum van Utrecht</strong>.
          </p>
        </div>
      </div>
    </section>
  );
}
